import React from 'react';

import {
  Box,
  Divider,
  Paper,
  styled
} from '@mui/material';



const DividerBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  gap: theme.spacing(3)
}));

const TabBarPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  border: '1px solid #F7F7F8',
  background: '#FAFAFA',
  gap: theme.spacing(3)
}));



export interface IProps {
  tabBarComponent: React.ReactNode;
  otherComponents: React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  return (
    <TabBarPaper elevation={0}>
      {props.tabBarComponent}

      <DividerBox>
        <Divider orientation="vertical" />

        <Divider orientation="vertical" />
      </DividerBox>

      {props.otherComponents}
    </TabBarPaper>
  );
};
